import React, { useState } from 'react';
import emailjs from 'emailjs-com';

function EmailForm({ onClose }) {
  const [formData, setFormData] = useState({
    userEmail: '',
    subject: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_7akoq3h';
    const templateID = 'template_3767mcp';
    const userID = 'OTGQwfF6FfMJQvvAm';

    emailjs.send(serviceID, templateID, formData, userID)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setShowSuccess(true);
      }, (error) => {
        console.log('FAILED...', error);
        alert('Failed to send email. Please try again.');
      });
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    onClose();
  };

  // Success Alert Box
  if (showSuccess) {
    return (
      <div style={styles.overlay}>
        <div style={styles.successContainer}>
          <button onClick={handleSuccessClose} style={styles.closeButton}>&times;</button>
          <div style={styles.successIcon}>✓</div>
          <h2 style={styles.successHeading}>Email Sent Successfully!</h2>
          <p style={styles.successMessage}>Your message has been delivered.</p>
          <button onClick={handleSuccessClose} style={styles.successButton}>Close</button>
        </div>
      </div>
    );
  }

  // Email Form
  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <button onClick={onClose} style={styles.closeButton}>&times;</button>
        <h2 style={styles.heading}>Send an Email</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label>Your Email Address:</label>
            <input
              type="email"
              name="userEmail"
              value={formData.userEmail}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label>Subject:</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>
          <div style={styles.formGroup}>
            <label>Message:</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              style={styles.textarea}
            />
          </div>
          <button type="submit" style={styles.button}>Send Email</button>
        </form>
      </div>
    </div>
  );
}

// Updated Responsive Styles
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  container: {
    width: '90%',
    maxWidth: '450px',
    maxHeight: '90%',  // Prevents it from being too tall on small screens
    overflowY: 'auto',
    boxSizing: 'border-box',
    backgroundColor: '#1B3244',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    color: '#fff',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  successContainer: {
    width: '90%',
    maxWidth: '400px',
    boxSizing: 'border-box',
    backgroundColor: '#1B3244',
    padding: '30px 20px',
    borderRadius: '10px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    color: '#fff',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  successIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    color: '#fff',
    marginBottom: '20px',
    fontWeight: 'bold',
  },
  successHeading: {
    fontSize: '1.5rem',
    marginBottom: '10px',
    color: '#fff',
  },
  successMessage: {
    fontSize: '1rem',
    marginBottom: '25px',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  successButton: {
    padding: '12px 30px',
    fontSize: '1rem',
    borderRadius: '5px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.3s ease-in-out',
  },
  heading: {
    fontSize: '1.5rem',
    textAlign: 'center',
    marginBottom: '15px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  formGroup: {
    marginBottom: '15px',
    textAlign: 'left',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '1rem',
    borderRadius: '5px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    color: '#000',
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '1rem',
    borderRadius: '5px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
    resize: 'vertical',
    backgroundColor: '#fff',
    color: '#000',
  },
  button: {
    padding: '12px',
    fontSize: '1rem',
    borderRadius: '5px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.3s ease-in-out',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'transparent',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: 'white',
    fontWeight: 'bold',
  },
};

export default EmailForm;